export default [
  {
    id: "small-business-webpage",
    name: "Content management",
    technical: "React, Node, Mongo, Markdown, CSS Grid",
    shortdescription: "A small business website with content management.",
    longdescription: "As final project during the Technigo Bootcamp I made a template for a small business website. Part of the tech requirement was to use an API in Node and a database in Mongo. The database is used to add content to the stories-page via an admin page. The only way to reach the admin-page is through a user login with token-based authorization. By writing with markdown it is possible to also style the content. The admin-page also handles messages from the visitors. The image-gallery on the start page is styled using CSS Grid.",
    link: "https://925-silver.netlify.com/#/",
    category: "code",
    image: "/images/925-desktop-startpage.png",
    image2: "/images/925-desktop-adminpage.png"
  }, {
    id: "faq-forum",
    name: "FAQ Forum",
    technical: "React, Node, Mongo",
    shortdescription: "Frontend and backend for a FAQ forum.",
    longdescription: "Frontend and backend for a FAQ-forum, using an API with three models to handel the visitors questions, login and adding FAQs to the accordion on the start page. This was a group-project where I mainly worked with the backend, the start page and the styling. The site is not deployed, the link below will take you to the repository on Github.",
    link: "https://github.com/katudd/faq-forum",
    category: "code",
    image: "/images/faq_desktop.png",
    image2: "/images/faq_admin_desktop.png"
  }, {
    id: "to-do-app",
    name: "To do App",
    technical: "React",
    shortdescription: "The classic To do App, built using React.",
    longdescription: "A classic To do app built using React. The assignment focus on building the form, handling state changes and use local storage to save state so that when the user reloads the page, they do not lose their todos. Built with three components – one for the input, one for the item and then App that stores an array of todo objects and then render the items as a list.",
    link: "https://katudd.github.io/todo-app/",
    category: "code",
    image: "/images/to_do_personal_desktop.png",
    image2: "/images/to_do_personal_mobile.png"
  }, {
    id: "css-grid",
    name: "CSS Grid",
    technical: "CSS Grid, html & css",
    shortdescription: "Implementation of CSS Grid.",
    longdescription: "A project built in hmtl and css copying the grid in the upper image, using CSS Grid. It is a rather new way to solve layouting problems. The combination of the grid and using viewport widht/height also for the fontstyling gives a smooth responsive behavior.",
    link: "https://katudd.github.io/css-grid/",
    category: "code",
    image: "/images/css-grid-desktop.png",
    image2: "/images/css-grid-copy.png"
  }, {
    id: "radio-player",
    name: "SR Radio Player",
    technical: "Fetch API in React",
    shortdescription: "Using Sveriges Radio's API to fetch playable audio stream.",
    longdescription: "A project built in React, using Sveriges Radio's API to fetch a JSON and render a list of channels with playable audio stream urls to create a working radio player. Built with two components – one for the player and App that map over the channels in the JSON.",
    link: "https://katudd.github.io/radio-player/",
    category: "code",
    image: "/images/radio.player-desktop.png",
    image2: "/images/radio.player-mobile.png"
  }, {
    id: "product-page",
    name: "Product Page",
    technical: "React with local JSON-file",
    shortdescription: "A product listing built with one component and a local JSON file.",
    longdescription: "On this product page a list of products from a local JSON file is iterated over to render a React component for each product. On hover over the box, the description shows.",
    link: "https://product-page.netlify.com",
    category: "code",
    image: "/images/productpage-desktop.png",
    image2: "/images/productpage-mobile.png"
  }, {
    id: "cookie-calendar",
    name: "Online Calendar",
    technical: "Javascript, html & css",
    shortdescription: "Cookie calendar revealing one recepie per day.",
    longdescription: "The idea of this group-project was to create a page which looks super christmasey and festive. A visitor that lands on the page, will see 24 windows. Each day, a new window is opened and the visitor can click through to see a recepie. The project was done in cooperation with Kivra, a company mad about cookies. During the project I mainly worked with design, grid and animation. I coded the recepies for day 2, 6, 10, 14, 18 and 22.",
    link: "https://katudd.github.io/accordion/",
    category: "code",
    image: "/images/cookie_calendar_desktop.png",
    image2: "/images/cookie2.gif"
  }, {
    id: "online-clock",
    name: "Online Clock",
    technical: "React",
    shortdescription: "An online clock built in React.",
    longdescription: "This clock is built following the  official React tutorial in using states and add local state to a class. To that is added the stop and reset and if you wait a minute you will se the colors change.",
    link: "https://katudd.github.io/clock/",
    category: "code",
    image: "/images/clock_desktop.png",
    image2: "/images/clock_tablet.png"
  }, {
    id: "habit-tracker",
    name: "Habit Tracker",
    technical: "React",
    shortdescription: "Mobile web App to track your habits.",
    longdescription: "This is a group project aiming to build a React mobile web App in which users can store their goals, and then keep track of whether they achieved the goal on a given day. The App has components for the startpage, the item listed on the page, the fill-in form and the calendar. I mainly worked with building the item-component.",
    link: "https://habit-tracker-katrin-uddstromer-technigo.netlify.com",
    category: "code",
    image: "/images/habit_tracker_mockup.png",
    image2: "/images/habit_tracker_screens.png"
  }, {
    id: "womsy-mobile-web",
    name: "Womsy Mobile Web",
    technical: "Sketch, Invision",
    shortdescription: "Design and UX prototyp for Womsy.",
    longdescription: "Design and UX of web protoptype for the startup Womsy – a digital living-room with women as target group. This consultant assignment was accomplished within very tight time frames and from simple idea sketches. Below is a link to the prototyp on Invision, where you can look through a few pages and do some clicking.",
    link: "https://invis.io/238X4IYZX#/196181790_Womsy_Fireplace",
    category: "design",
    image: "/images/Womsy_mockup.png",
    image2: "/images/womsy_screens.jpg"
  }, {
    id: "magazine",
    name: "OM Magasin",
    technical: "InDesign",
    shortdescription: "Customer magazine for TRR Trygghetsrådet.",
    longdescription: "Art Direction for TRR Trygghetsrådets customer magazine OM Magasin, including adapting the content to social media. I am also a member of the editorial board. The edition is 50,000 copies and is sent to management teams at TRR’s member companies. The lastest reader survey show that 8 out of 10 subscribers read the magazine. My re-design got the highest scores for improvements.",
    link: "https://issuu.com/trygghetsradet/docs/om_2_15_low",
    category: "design",
    image: "/images/OM_Mohammadi_cover.png",
    image2: "/images/OM_Mohammadi_pages.png"
  }, {
    id: "algorithms",
    name: "Algorithms",
    technical: "Photoshop, Illustrator, InDesign",
    shortdescription: "Editorial illustration for article about algorithms.",
    longdescription: "Illustration for article about algorithms, how they affect what you get exposed to onlin, and the risks of living in a filter bubble without reflecting over it. I use illustration to test new ideas and techniques, and in this project I was inspiered by Vasjen Katros' project Baugasm.",
    link: "https://issuu.com/trygghetsradet/docs/om_2_17_final/30",
    category: "design",
    image: "/images/algorithms_2.png",
    image2: "/images/algorithms_1.png"
  }, {
    id: "photo-montage",
    name: "Photo Montage",
    technical: "Photoshop, Illustrator, InDesign",
    shortdescription: "Editorial illustration for article about virtual reality.",
    longdescription: "Illustration for article about virtual reality, where we might not know if what we experience is real or not. I use illustration to test new ideas and techniques, and in this project I was inspiered by Coldplays' increadibly cool video Up & Up.",
    link: "https://issuu.com/trygghetsradet/docs/om_magasin_nr_2_2016/30",
    category: "design",
    image: "/images/photo_montage_1.png",
    image2: "/images/photo_montage_2.png"
  }, {
    id: "social-video",
    name: "Social Video",
    technical: "AfterEffects, MediaEncoder, Photoshop, Illustrator",
    shortdescription: "Animated retrospective over the past year.",
    longdescription: "Animated social video for the startup Allihoopa, showing the followers what has happend during the companys first intense year. Reusing bits and pieces of already published content and combining it to something new.",
    link: "https://vimeo.com/250640193",
    category: "design",
    image: "/images/social-video_1.png",
    image2: "/images/social-video_2.png"
  }, {
    id: "tutorial",
    name: "Tutorial",
    technical: "AfterEffects, MediaEncoder, Photoshop",
    shortdescription: "Animated short tutorial in After Effects.",
    longdescription: "Animated short tutorial published in Allihoopas' social channels to help users getting started with a new feature. The challange is to make it clear and easy to follow in no more than 30 seconds.",
    link: "https://vimeo.com/250643150",
    category: "design",
    image: "/images/tutorial_1.png",
    image2: "/images/tutorial_2.png"
  }
]



// WEBPACK FOOTER //
// ./src/data/projects.js